import pluralize from "pluralize";

import { Maybe } from "@/types";

import { Offer } from "./types";

export const nightsOnOffer = (offer?: Offer): Maybe<number> =>
  offer?.accommodation.reduce((total, accom) => total + accom.nights, 0) ||
  null;

export const shouldRemoveEnquiry = (
  totalPax: number,
  minLowPax: number,
): boolean => {
  return totalPax < minLowPax;
};

export const roundsOnOffer = (offer?: Offer): Maybe<number> => {
  const nights = nightsOnOffer(offer);

  if (!offer || !nights) {
    return null;
  }

  const allocated = offer.roundAllocation.allocated.reduce(
    (total, round) => total + round.rounds,
    0,
  );
  const unallocated = offer.roundAllocation.unallocated?.rounds || 0;
  const unlimited = offer.roundAllocation.unlimited.length > 0 ? nights + 1 : 0;

  return allocated + unallocated + unlimited;
};

export const displayNightsOnOffer = (offer?: Offer): string => {
  const nights = nightsOnOffer(offer);

  if (!offer || !nights) {
    return "";
  }

  return pluralize("Night", nights, true);
};

export const displayRoundsOnOffer = (offer?: Offer): string => {
  const rounds = roundsOnOffer(offer);

  if (!offer || !rounds) {
    return "";
  }

  if (offerHasUnlimitedRounds(offer)) {
    return "Unlimited Rounds";
  } else {
    return pluralize("Round", rounds, true);
  }
};

export const offerHasUnlimitedRounds = (offer?: Offer): boolean => {
  if (!offer) {
    return false;
  }

  return !!offer.roundAllocation.unlimited.length;
};
